import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import { Icono } from './Icono';

interface Aviso {
  id: number;
  tono: 'exito' | 'error';
  texto: string;
}

const Contexto = createContext<(texto: string, tono?: Aviso['tono']) => void>(() => undefined);

/**
 * Confirmaciones que no interrumpen: aparecen, se leen y se van solas. En el mostrador esto es
 * importante — un modal de "pago registrado" obligaría a un clic más con gente esperando.
 */
export function ProveedorAvisos({ children }: { children: ReactNode }) {
  const [avisos, setAvisos] = useState<Aviso[]>([]);
  const avisar = useCallback((texto: string, tono: Aviso['tono'] = 'exito') => {
    const id = Date.now() + Math.random();
    setAvisos((lista) => [...lista.slice(-3), { id, tono, texto }]);
    setTimeout(() => setAvisos((lista) => lista.filter((aviso) => aviso.id !== id)), tono === 'error' ? 7000 : 3500);
  }, []);
  const valor = useMemo(() => avisar, [avisar]);
  return (
    <Contexto.Provider value={valor}>
      {children}
      <div className="avisos" role="status" aria-live="polite">
        {avisos.map((aviso) => (
          <div key={aviso.id} className={`aviso aviso--${aviso.tono}`}>
            <Icono nombre={aviso.tono === 'exito' ? 'check' : 'alerta'} />
            <span>{aviso.texto}</span>
          </div>
        ))}
      </div>
    </Contexto.Provider>
  );
}

export function useAvisar() {
  return useContext(Contexto);
}
